"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const atoms_1 = require("@components/atoms");
const AccountInHeader_1 = require("@components/organisms/AccountInHeader");
const _store_1 = __importDefault(require("@store")); // Component
var Quiz = function Quiz() {
    var _useGlobal = _store_1.default(function (state) {
        return state.panel;
    }, function (actions) {
        return actions.setPanel;
    }), setPanel = _useGlobal[1];
    return /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null, /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Column, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.EyebrowLabel, null, "Account Created"), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Headline, null, "Welcome to PRIOR, take a moment to personalize your account."), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Caption, null, "Etiam porta sem malesuada magna mollis euismod."), /*#__PURE__*/ react_1.default.createElement(atoms_1.Button, null, "Get Started"), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.SwitchMode, {
        onClick: function onClick() {
            return setPanel('home');
        }
    }, "Maybe Later")), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Column, null, "Graphic go here"));
};
exports.default = Quiz;
